import React from "react";
import { SupplyWalkEditableContainer } from "../supply_walk_editable/container";

export const PoInboxPage = () => <SupplyWalkEditableContainer />;
